export function renderProductPopup(item) {
  const formId = item.popupFormId?.value?.trim();
  const disabled = item.buttonDisabled?.value === 'true';
  if (!disabled && (item.popupEnabled?.value !== 'true' || !formId)) return '';
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const label = item.popupButtonText?.value?.trim() || (disabled ? 'COMING SOON' : 'NOTIFY ME');
  if (disabled) {
    return `<button type="button" class="ml-6 md:ml-0 block text-dark uppercase font-bold bg-white" data-product-popup data-product-button-disabled disabled aria-disabled="true">${escape(label)}</button>`;
  }
  return `<button type="button" class="klaviyo-form-trigger ml-6 md:ml-0 block text-dark uppercase cursor-pointer font-bold bg-white" data-product-popup data-klaviyo-form-id="${escape(formId)}" onclick="event.preventDefault(); event.stopPropagation(); window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', this.dataset.klaviyoFormId]);">${escape(label)}</button>`;
}

export const cardActionSelector = ':scope > .product-cta, :scope > [data-product-popup], :scope > klaviyo-bis, :scope > a.uppercase';

export function swapCardAction(card, source) {
  const current = card.querySelector(cardActionSelector);
  const next = source.querySelector(cardActionSelector);
  if (current && next) current.replaceWith(next.cloneNode(true));
}
